var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":""}},[_vm._t("default",function(){return [_c('v-toolbar-title',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]}),_c('v-spacer'),_c('base-app-close-icon-button',{on:{"click":_vm.close}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }